import { createStore } from "@stencil/store";
import { PPNDealerSearchResult } from "../entities/dealer-response";
import { LatLong, Prediction } from "../entities/places";

export interface DealerSearchResults {
  searchTerm: string;
  placeCoordinates: LatLong | null;
  radius: string;
  results: string[] | null;
  ppnDealers: { [dealerId: string]: PPNDealerSearchResult };
  dealersOfRegion: any;
  predictions: Prediction[];
}

export const dealerSearchResultsStore = createStore<DealerSearchResults>({
  searchTerm: "",
  placeCoordinates: null,
  radius: "50",
  results: null,
  ppnDealers: {},
  dealersOfRegion: { regions: [] },
  predictions: [],
});
